<template>
  <div class="approval-leave-setting-page" v-if="types !== null">
    <kd-cell-group>
      <kd-cell type="normal" title="自动通过类型" :subtitle="showValue" :arrow="true" @click="showPicker = true" />
    </kd-cell-group>

    <kd-picker :visible.sync="showPicker" v-model="settingValue" :options="settingOptions" @change="changeHandle" />
  </div>
</template>
<script lang="ts">
import { BasePage, Component } from 'kuaidong-component'
import { KdCellGroup, KdCell, KdPicker } from 'kuaidong-ui'
import { StudentLeave } from 'kuaidong-model'
import { AApprovalLeave } from 'kuaidong-api'

@Component({
  components: {
    KdCellGroup,
    KdCell,
    KdPicker,
  },
})
export default class ApprovalLeaveSettingPage extends BasePage {
  showPicker = false

  settingValue = ''
  types: string[] | null = null

  get settingOptions() {
    const result = [{ label: '未设置', value: '' }]
    for (const key in StudentLeave) {
      result.push({
        label: (StudentLeave as any)[key],
        value: key,
      })
    }
    return result
  }

  async mounted() {
    this._LoadingAsyncTask(async () => {
      this.types = await AApprovalLeave.getLeaveSetting()
      if (this.types.length > 0) {
        this.settingValue = this.types[0]
      }
    })
  }

  get showValue() {
    if (this.settingValue) {
      return (StudentLeave as any)[this.settingValue]
    } else {
      return '未设置'
    }
  }

  async changeHandle() {
    console.log(this.settingValue)
    await AApprovalLeave.updateleaveSetting(this.settingValue ? [this.settingValue] : [])
    this.toast('设置成功！')
  }
}
</script>
<style lang="less">
.approval-leave-setting-page {
  .kd-cell.kd-cell__editable > .kd-cell__wrapper > .kd-cell__content .kd-cell__subtitle {
    color: #b8b8b8;
  }
}
</style>
